<template>
  <div class="wrapper">
    <change-logs-filters v-model="filter"></change-logs-filters>
    <change-logs-list :filter="query" v-model="customer.change_logs"></change-logs-list>
  </div>
</template>
<script>
export default {
  props: ['customer'],
  data: function () {
    return {
      filter: {}
    };
  },
  computed: {
    query() {
      let filter = this.filter;
      filter.customer_id = this.customer.id;
      return _.omitBy(filter, (v) => {
        return _.isEmpty(v);
      });
    }
  }
};
</script>
